import { Spacing } from 'UI'
import { cardTypes } from './UI'

export default theme => ({
  paypallRoot: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  addPaypal: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    border: '1px solid',
    justifyContent: 'space-between',
    padding: 24,
    borderColor: theme.neutral[0],
    borderBottomColor: ({ visibleForm }) => !(visibleForm.type === cardTypes.paypal && visibleForm.open) ? theme.neutral[0] : theme.neutral[400],
    borderRadius: ({ visibleForm }) => !(visibleForm.type === cardTypes.paypal && visibleForm.open) ? 8 : '8px 8px 0 0',
    backgroundColor: theme.neutral[400],
    marginTop: 12
  },
  paypallIcon: {
  },
  creditCardRoot: {
    width: '100%'
  },
  creditCardIcon: {
    marginRight: 10
  },
  arrowIcon: {
    color: theme.primary[0],
    fontSize: 14
  },
  addCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 24,
    border: '1px solid',
    borderColor: theme.neutral[0],
    borderBottomColor: ({ visibleForm }) => !(visibleForm.type === cardTypes.cb && visibleForm.open) ? theme.neutral[0] : theme.neutral[400],
    backgroundColor: theme.neutral[400],
    cursor: 'pointer',
    borderRadius: ({ visibleForm }) => !(visibleForm.type === cardTypes.cb && visibleForm.open) ? 8 : '8px 8px 0 0'
  },
  addCardCmi: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 24,
    border: '1px solid',
    borderColor: theme.neutral[0],
    borderBottomColor: ({ visibleForm }) => !(visibleForm.type === cardTypes.cmi && visibleForm.open) ? theme.neutral[0] : theme.neutral[400],
    backgroundColor: theme.neutral[400],
    cursor: 'pointer',
    borderRadius: ({ visibleForm }) => !(visibleForm.type === cardTypes.cmi && visibleForm.open) ? 8 : '8px 8px 0 0',
    marginTop: 12
  },
  addVirement: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 24,
    border: '1px solid',
    borderColor: theme.neutral[0],
    borderBottomColor: ({ visibleForm }) => !(visibleForm.type === cardTypes.bp && visibleForm.open) ? theme.neutral[0] : theme.neutral[400],
    backgroundColor: theme.neutral[400],
    cursor: 'pointer',
    borderRadius: ({ visibleForm }) => !(visibleForm.type === cardTypes.bp && visibleForm.open) ? 8 : '8px 8px 0 0',
    marginTop: 12
  },
  newCardInfos: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    border: '1px solid',
    borderColor: theme.neutral[0],
    borderTopColor: theme.neutral[400],
    borderRadius: '0 0 8px 8px',
    backgroundColor: theme.neutral[400],
    position: 'relative',
    padding: () => Spacing(0, 5, 5, 5)
  },
  paypalGroup: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid',
    borderColor: theme.neutral[0],
    borderTopColor: theme.neutral[400],
    backgroundColor: theme.neutral[400],
    position: 'relative',
    borderRadius: '0 0 8px 8px',
    padding: () => Spacing(0, 5, 5, 5)
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  arrowDown: {
    position: 'absolute',
    right: 80,
    top: 0,
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderTop: '10px solid',
    borderTopColor: theme.primary[0]
  },
  paypalLink: {
    width: '100%',
    height: 40,
    backgroundColor: theme.secondary[0],
    border: `1px solid ${theme.neutral[0]}`,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  paypalLogoClass: {
    height: '60%'
  },
  paragraph2: {
    padding: () => Spacing(5, 0, 0, 0),
    display: 'flex'
  },
  icon: {
    color: theme.neutral[400],
    fontSize: 14,
    marginRight: 8
  }
})
